import type {
  Cart,
  CartCustomerInfo,
  CartImageUrl,
  CartWithImagesSummary,
  CartsWithReportUrl,
} from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

/** Fetch my carts */
export const fetchMyCarts = async () => {
  const response = await gozokiApiWithAuth.get<CartsWithReportUrl[]>('/carts/me')
  return response.data
}

export const fetchCart = async (id: number) => {
  const response = await gozokiApiWithAuth.get<Cart>(`/carts/${id}`)
  return response.data
}

export const fetchCartCustomerInfo = async (cartId: number) => {
  const response = await gozokiApiWithAuth.get<CartCustomerInfo>(`/carts/${cartId}/customer-info`)
  return response.data
}

export const fetchCartsWithImages = async (
  page: number,
  pageSize: number,
  storeId: number | null,
) => {
  const response = await gozokiApiWithAuth.get<{
    data: CartWithImagesSummary[]
    meta: {
      total: number
      perPage: number
      currentPage: number
      lastPage: number
    }
  }>(`/carts-with-images?page=${page}&pageSize=${pageSize}${storeId ? `&store=${storeId}` : ''}`)
  return response.data
}

export const fetchCartImages = async (cartId: number) => {
  const response = await gozokiApiWithAuth.get<{ images: CartImageUrl[] }>(
    `/carts/${cartId}/images`,
  )
  return response.data.images
}
